// BO UI language toggle (docs/specs/2026-10-06-bo-language-toggle-user-menu-design.md L3).
//
// The navbar's user menu has ONE item that flips between Thai and English; its
// badge shows the language a click switches TO. The rules live here, free of
// Vue / DOM imports, because DashboardNavbar.vue cannot be mounted under this
// repo's jest setup.

// The locale a toggle click switches to: th -> en, en -> th. Anything else
// (unset, unknown) falls back to Thai, the BO's default language.
export function nextLocale(current) {
  if (current === "th") return "en";
  if (current === "en") return "th";
  return "th";
}

// The short badge text for a locale code. Unknown codes read as "TH" so the
// badge never renders blank or a raw code.
export function localeLabel(code) {
  if (code === "en") return "EN";
  return "TH";
}
